import {
  deleteLocalSelectedOU,
  useAppSelector,
  useQuery
} from '@monorepo/shared';
import { selectPermission } from '@monorepo/shared/store/authSlice';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from 'rsuite';
import { t } from 'i18next';
import {
  selectAccounts,
  selectLoginAccount
} from '@monorepo/shared/store/accountSlice';
import { selectGroupRegions } from '@monorepo/shared/store/groupSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';

export const LoginRedirect = () => {
  let query = useQuery();
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const debug_key = query.get('debug_key') || state?.debug_key;
  const userPermission = useAppSelector(selectPermission);
  const loginAccount = useAppSelector(selectLoginAccount);
  const groupRegions = useAppSelector(selectGroupRegions);
  const ouData = useAppSelector(selectOU);
  const accounts = useAppSelector(selectAccounts);
  useEffect(() => {
    if (userPermission === 'unset') {
      navigate('/permission', {
        state: {
          redirect_path: pathname,
          debug_key: debug_key
        }
      });
      deleteLocalSelectedOU();
    } else {
      let isRedirect: boolean = false;
      if (
        // !ouData?.length &&
        // !groupRegions?.length &&
        Object.keys(accounts).length === 1
      ) {
        isRedirect = true;
      }
      navigate('/organization', {
        state: {
          debug_key: debug_key,
          redirect_obj: isRedirect
            ? {
                account_id: loginAccount?.account_id,
                user_id: loginAccount?.user_id
              }
            : undefined
        }
      });
    }
  }, [userPermission, loginAccount, groupRegions]);
  return (
    <>
      <Loader center content={t('common.loading')} />
    </>
  );
};
